import type { ReactNode } from 'react';
import { memo, Children } from 'react';
import { Button } from '@patternfly/react-core/dist/dynamic/components/Button';
import { Popover } from '@patternfly/react-core/dist/dynamic/components/Popover';
import { PopoverProps } from '@patternfly/react-core/dist/dynamic/components/Popover';
import { OutlinedQuestionCircleIcon } from '@patternfly/react-icons/dist/dynamic/icons/outlined-question-circle-icon';
import { useTranslation } from 'react-i18next';

export const FieldLevelHelp = memo<FieldLevelHelpProps>(
  ({ children, popoverHasAutoWidth, testId }) => {
    const { t } = useTranslation();
    if (Children.count(children) === 0) {
      return null;
    }
    return (
      <Popover
        aria-label={t('public~Help')}
        bodyContent={children}
        hasAutoWidth={popoverHasAutoWidth}
      >
        <Button
          icon={<OutlinedQuestionCircleIcon className="co-field-level-help__icon" />}
          aria-label={t('public~Help')}
          variant="link"
          isInline
          className="co-field-level-help"
          data-test-id={testId || null}
        />
      </Popover>
    );
  },
);

type FieldLevelHelpProps = {
  children: ReactNode;
  popoverHasAutoWidth?: PopoverProps['hasAutoWidth'];
  testId?: string;
};
